
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dealers/[id]",
      function () {
        return require("private-next-pages/dealers/[id].jsx");
      }
    ]);
  